export default "__VITE_ASSET__CBTfGEUe__"